import $ from 'jquery';

export function initNavigation() {
    const $nav = $('.nav');
    if (!$nav.length) return; // Exit if no navigation exists

    // ---------------------------------------
    // Nav open/close
    // ---------------------------------------
    const $navToggle = $('.navToggle');
    const $mobileClose = $('.mobileCloseNavBtn');
    const $navLinks = $('.nav__inner__links');

    if ($navToggle.length && $navLinks.length) {
        $navToggle.on('click', function () {
            const isOpen = $navLinks.toggleClass('--open').hasClass('--open');
            $('html').toggleClass('overflow-hidden', isOpen);
        });
    }

    if ($mobileClose.length && $navLinks.length) {
        $mobileClose.on('click', function () {
            $navLinks.removeClass('--open');
            $('html').removeClass('overflow-hidden');
        });
    }

    // ---------------------------------------
    // Search toggle
    // ---------------------------------------
    const $searchBar = $('.search-bar');
    const $searchToggle = $('.searchToggle');
    const openClass = '--open';

    if ($searchBar.length && $searchToggle.length) {
        $searchToggle.on('click', function (e) {
            e.stopPropagation();
            $searchBar.toggleClass(openClass);
            if ($searchBar.hasClass(openClass)) {
                $searchBar.find('.closeSearchBtn').focus();
            }
        });

        $searchBar.on('click', function (e) {
            e.stopPropagation();
        });

        $(document).on('click', function () {
            $searchBar.removeClass(openClass);
        });

        $('.closeSearchBtn').on('click', function () {
            $searchBar.removeClass(openClass);
        });
    }

    // ---------------------------------------
    // Allow native scroll inside nav scroll area
    // ---------------------------------------
    const navScrollable = document.querySelector('.nav__inner__links');
    if (navScrollable) {
        ['wheel', 'touchmove'].forEach(evt => {
            navScrollable.addEventListener(evt, e => e.stopPropagation(), { passive: false });
        });
    }

    // ---------------------------------------
    // Nav background toggle on scroll
    // ---------------------------------------
    function checkNavPosition() {
        const scrollTop = $(window).scrollTop();
        if (scrollTop > $nav.outerHeight()) {
            $nav.addClass('--bg');
        } else {
            $nav.removeClass('--bg');
        }
    }

    checkNavPosition();
    $(window).on('scroll', checkNavPosition);
}

// ---------------------------------------
// Navigation dropdowns (click + keyboard)
// ---------------------------------------
export function initNavigationDropdowns() {
    const $nav = $('.nav');
    if (!$nav.length) return; // No nav = no dropdowns

    function getDropdowns() {
        return $('li:has(.has-link)');
    }

    function closeAllDropdowns() {
        getDropdowns().removeClass('active');
        $('.dd').stop(true, true).slideUp(0);
    }

    function toggleDropdown($li, $submenu) {
        const isActive = $li.hasClass('active');
        closeAllDropdowns();

        if (!isActive) {
            $li.addClass('active');
            $submenu.stop(true, true).slideDown(0);
        } else {
            $li.removeClass('active');
            $submenu.stop(true, true).slideUp(0);
        }
    }

    function initDesktopHover() {
        const $dropdowns = getDropdowns();

        $dropdowns.each(function () {
            const $li = $(this);
            const $button = $li.find('.has-link').first();
            const $submenu = $li.find('.dd').first();

            if ($submenu.length) {
                $li.on('mouseenter', () => toggleDropdown($li, $submenu));
                $li.on('mouseleave', closeAllDropdowns);

                $button.on('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        toggleDropdown($li, $submenu);
                    }
                });

                $submenu.find('a').last().on('keydown', function (e) {
                    if (e.key === 'Tab' && !e.shiftKey) {
                        closeAllDropdowns();
                    }
                });
            }
        });
    }

    function initMobileClick() {
        const $dropdowns = getDropdowns();

        $dropdowns.each(function () {
            const $li = $(this);
            const $button = $li.find('.has-link').first();
            const $mobileBtn = $li.find('.dd-btn-mobile').first();
            const $submenu = $li.find('.dd').first();

            if ($submenu.length) {
                $mobileBtn.on('click', function (e) {
                    e.preventDefault();
                    toggleDropdown($li, $submenu);
                });

                $button.on('click', function (e) {
                    e.preventDefault();
                    toggleDropdown($li, $submenu);
                });

                $button.add($mobileBtn).on('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        toggleDropdown($li, $submenu);
                    }
                });

                $submenu.find('a').last().on('keydown', function (e) {
                    if (e.key === 'Tab' && !e.shiftKey) {
                        closeAllDropdowns();
                    }
                });
            }
        });
    }

    function bindDropdowns() {
        const $dropdowns = getDropdowns();
        $dropdowns.off('mouseenter mouseleave click keydown');
        $('.dd-btn-mobile').off('click keydown');

        if (window.innerWidth > 1250) {
            initDesktopHover();
        } else {
            initMobileClick();
        }
    }

    bindDropdowns();

    $(window).on('resize', function () {
        bindDropdowns();
        closeAllDropdowns();
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('li:has(.has-link), .dd, .dd-btn-mobile').length) {
            closeAllDropdowns();
        }
    });
}